import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { TenantMath } from "../../modelau/defnyddiwr/rol";

@Injectable({
  providedIn: "root",
})
export class StorfaDefnyddiwrService {
  private storfaDefnyddiwrSubject = new BehaviorSubject<boolean | null>(null);
  public readonly storfaDefnyddiwr$ = this.storfaDefnyddiwrSubject.asObservable();

  private readonly storageKey = "asedaufflyd:defnyddiwr::";

  setio(key: string, data: any) {
    // Normalize to a string for comparison
    const value = typeof data === "string" ? data : JSON.stringify(data);

    // If value already in storage, do nothing (avoid emitting duplicate events)
    const existing = localStorage.getItem(`${this.storageKey}${key}`);
    if (existing === value) {
      return;
    }

    localStorage.setItem(`${this.storageKey}${key}`, value);
    this.storfaDefnyddiwrSubject.next(true);
  }

  nol(key: string): string {
    return localStorage.getItem(`${this.storageKey}${key}`);
  }

  tynnuEitem(key: string, overrideStorageKey: boolean = false) {
    if (overrideStorageKey) {
      localStorage.removeItem(`${key}`);
    } else {
      localStorage.removeItem(`${this.storageKey}${key}`);
    }

    this.storfaDefnyddiwrSubject.next(true);
  }

  clirioPopeth() {
    localStorage.clear();
    this.storfaDefnyddiwrSubject.next(true);
  }

  nolDefnyddiwrId(): string {
    return this.nolProffil().id;
  }

  nolEnwDefnyddiwr(): string {
    return this.nolProffil().enw;
  }

  nolEnwTenant(): string {
    return this.nolProffil()?.tenant;
  }

  cadarnhauOsYnTenantDrwyTenantMath(tenantMath: TenantMath): boolean {
    return this.nolEnwTenant() === tenantMath;
  }

  // Mae hwn yn tickbox yn erbyn defnyddiwr. Hwn yn cloi lawr rhai darnau o'r UI.
  nolRhwystroCauGwaith(): boolean {
    const proffilYma = this.nolProffil();

    return proffilYma?.rhwystrocaugwaith ?? false;
  }

  nolProffil(): any {
    try {
      return JSON.parse(this.nol("proffil"));
    } catch (error) {
      alert(error);
    }
  }
}
